import { Injectable } from '@angular/core';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';
import { BehaviorSubject, Observable } from 'rxjs';

export interface Announcement {
    id: string;
    text: string;
    onClick?: (event?: Event) => any;
    dismissable?: boolean;
    icon?: string;
}

@Injectable({ providedIn: 'root' })
export class AnnouncementService {
    private announcementsData: Array<Announcement> = [];

    public announcementsSubject: BehaviorSubject<Array<Announcement>> = new BehaviorSubject(
        this.announcementsData
    );

    public announcementsStream: Observable<Array<Announcement>>;

    constructor() {
        SingletonServiceGuard.register('AnnouncementService');
        this.announcementsStream = this.announcementsSubject.asObservable();
    }

    public addAnnouncement(announcement: Announcement): void {
        if (
            !this.announcementsData.some(
                (exisitingAnnouncement) => exisitingAnnouncement.id === announcement.id
            )
        ) {
            this.announcementsData.push(announcement);
            this.announcementsSubject.next(this.announcementsData);
        }
    }

    public removeAnnouncement(id: string): void {
        this.announcementsData = this.announcementsData.filter(
            (announcement) => announcement.id !== id
        );
        this.announcementsSubject.next(this.announcementsData);
    }

    public clearAnnouncements(): void {
        this.announcementsData = [];
        this.announcementsSubject.next(this.announcementsData);
    }
}
